import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()

const fetchPOToVendorDateUpdate = () => AxiosClient.get('/fetch-list-vendor-date-update')

const fetchPOToVendorDateUpdateParams = (po_search) => AxiosClient.get(`/fetch-list-vendor-date-update?po_search=${po_search}`)
const updateDateforVendor = payload=> AxiosClient.post('/update-vendor-date',payload);
const updateDateforUser = payload=> AxiosClient.post('/update-user-date',payload);


export {
    fetchPOToVendorDateUpdate,
    updateDateforVendor,
    updateDateforUser,
    fetchPOToVendorDateUpdateParams
  }